import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../actions';
import { setG2Loading } from '../actions/App';
import { getUserProfile } from '../actions/Auth';

import { APIintegrationCallMethod } from '../api/Integrations';

import { sendTrackingEvent } from '../helpers';
import { getSetting } from '../helpers/Settings';

const G2ReviewButton = ({ dispatch, profile, g2Loading }) => {
  const [showButton, setShowButton] = useState(profile.show_g2_review_button);
  const intl = useIntl();

  const fetchReviewStatus = useCallback(() => {
    if (showButton && !g2Loading) {
      dispatch(setG2Loading(true));
      APIintegrationCallMethod('g2', 'getReviewStatus').then((res) => {
        if (res.review_exists) {
          dispatch(getUserProfile({ ...profile, show_g2_review_button: false }));
          setShowButton(false);
        }
        dispatch(setG2Loading(false));
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    fetchReviewStatus();
  }, [fetchReviewStatus]);

  if (getSetting('cs1') || !profile.show_g2_review_button) {
    return null;
  }

  if (!showButton) {
    return null;
  }

  const handleOpenModal = (e) => {
    e.preventDefault();
    sendTrackingEvent('g2-review-button-clicked');
    dispatch(showModal('G2ReviewModal', {
      className: 'modal-g2-review',
    }));
  };

  return (
    <div className="g2-review-button">
      <Button id="g2-review" outline onClick={handleOpenModal}>
        <img src="/images/integrations/g2-logo-r.png" alt="G2" />
        {intl.formatMessage({ defaultMessage: 'Review us on G2' })}
      </Button>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  g2Loading: state.App.g2Loading,
});

G2ReviewButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  g2Loading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(G2ReviewButton);
